// removed by extract-text-webpack-plugin
module.exports = {"closed":"_2VVuLeDqc9"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountCard/RouteTable/RouteTable.module.less
// module id = 977
// module chunks = 3